import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const AccrdnNoticeType = styled.div`
  .accordion-item {
    position: relative;

    + .accordion-item {
      margin-top: 20px;

      .accordion-label {
        border-top: 1px solid #eee;

        > .label {
          padding: 18px 0;
        }
      }
    }

    .accordion-label {
      margin: 0 20px;

      > .label {
        padding: 10px 0;

        .agree-title {
          font-size: 14px;

          .checkbox {
            pointer-events: auto;
            vertical-align: top;

            .label {
              flex-direction: row;
              font-size: 14px;
              line-height: 135%;
              padding: 0;
              margin-left: 10px;
            }
          }
        }
      }
    }

    .accordion-panel {
      max-height: initial;

      .notice-wrap {
        padding: 0 20px;

        .notice-inner {
          padding: 16px;
          background: #f6f6f6;

          .notice-title {
            font-size: 14px;
            line-height: 150%;
            color: #000;

            + ul {
              margin-top: 3px;
            }
          }

          ul > li {
            position: relative;
            font-size: 13px;
            line-height: 150%;
            padding-left: 20px;
            word-break: keep-all;
            word-wrap: break-word;
            color: #777;

            &:after {
              display: block;
              content: '';
              position: absolute;
              top: 9px;
              left: 9px;
              width: 3px;
              height: 3px;
              border-radius: 50%;
              background: #777;
            }

            + li {
              margin-top: 3px;
            }

            ol {
              margin-top: 4px;
              padding-left: 9px;
            }

            strong {
              font-weight: 600;
            }
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .accordion-item {
      + .accordion-item {
        margin-top: ${mixin.pxToVw('20')};

        .accordion-label {
          > .label {
            padding: ${mixin.pxToVw('18 0')};
          }
        }
      }

      .accordion-label {
        margin: ${mixin.pxToVw('0 20')};

        > .label {
          padding: ${mixin.pxToVw('10 0')};

          .agree-title {
            font-size: ${mixin.pxToVw('14')};

            .checkbox {
              .label {
                font-size: ${mixin.pxToVw('14')};
                margin-left: ${mixin.pxToVw('10')};
              }
            }
          }

          .arrow {
            width: ${mixin.pxToVw('14')};
            height: ${mixin.pxToVw('14')};
          }
        }
      }

      .accordion-panel {
        .notice-wrap {
          padding: ${mixin.pxToVw('0 20')};

          .notice-inner {
            padding: ${mixin.pxToVw('16')};

            .notice-title {
              font-size: ${mixin.pxToVw('14')};

              + ul {
                margin-top: ${mixin.pxToVw('3')};
              }
            }

            ul > li {
              font-size: ${mixin.pxToVw('13')};
              padding-left: ${mixin.pxToVw('20')};

              &:after {
                top: ${mixin.pxToVw('9')};
                left: ${mixin.pxToVw('9')};
                width: ${mixin.pxToVw('3')};
                height: ${mixin.pxToVw('3')};
              }

              + li {
                margin-top: ${mixin.pxToVw('3')};
              }

              ol {
                margin-top: ${mixin.pxToVw('4')};
                padding-left: ${mixin.pxToVw('9')};
              }
            }
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .accordion-item {
      + .accordion-item {
        margin-top: 44px;

        .accordion-label > .label {
          padding: 24px 0;
        }
      }

      .accordion-label {
        margin: 0;

        > .label {
          padding: 16px 0;

          .agree-title {
            font-size: 16px;

            .checkbox .label {
              font-size: 16px;
            }
          }
        }
      }

      .accordion-panel {
        .notice-wrap {
          padding: 0;
        }
      }
    }
  }
`;
